namespace GeniuzPOS.CustomReport {
    export interface ReportCustomerSurveyRow {
        Id?: string;
        SurveyCode?: string;
        Question?: string;
        ChoiceId?: number;
        Choice?: string;
        Qty?: number;
        DtList?: ReportCustomerSurveyTranDtRow[];
    }

    export namespace ReportCustomerSurveyRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SurveyCode';
        export const localTextPrefix = 'CustomReport.ReportCustomerSurvey';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            SurveyCode = "SurveyCode",
            Question = "Question",
            ChoiceId = "ChoiceId",
            Choice = "Choice",
            Qty = "Qty",
            DtList = "DtList"
        }
    }
}
